import type {IframeOpenData} from '@yandex-int/messenger.widget'
import {useCallback, useContext} from 'react'

import {SupportWidgetContext} from './SupportWidgetProvider'

export const useSupportWidgetShow = (params?: IframeOpenData, callback?: (error?: void | Error) => void) => {
  const widget = useContext(SupportWidgetContext)

  return useCallback(() => {
    widget?.show(params, callback)
  }, [widget, params, callback])
}
